import { SANDBOX_PREVIEW_POSTMESSAGE_SOURCE } from '../../sandboxPreview'
import { SANDBOX_PRESET_TAG as T } from '../presetTags'
import { SANDBOX_PRESET_BODY_CSS, type SandboxComponentPreset } from '../../sandboxPresetTypes'

/**
 * Minimal intro page: typography, a CTA button, and postMessage to the parent so the library tab can flash.
 * Useful for verifying the iframe ↔ parent bridge (`postMessage` + `MessageEvent.source`).
 */
const shell = SANDBOX_PRESET_BODY_CSS

const preset: SandboxComponentPreset = {
  id: 'starter',
  category: 'basics',
  title: 'Starter',
  description:
    'Heading, paragraph, and a “Click here” button that asks the parent page to pulse the component-library tab (postMessage).',
  tags: [T.basics, T.button],
  html: `<!-- Page title — data-testid is for Playwright; optional in your own pages -->
<h1 data-testid="preset-starter-heading">Hello</h1>

<!-- Static copy; live preview is driven by the HTML/CSS/JS editors in the sandbox -->
<p>Edit HTML, CSS, and JS. Preview updates after a short pause when live reload is on.</p>

<!-- Button wires to JS below; id is used by getElementById -->
<button type="button" id="sandbox-starter-cta" data-testid="sandbox-starter-cta">Click here</button>`,
  css: `${shell}

/* Accent heading */
h1 {
  color: var(--nogrok-preview-primary);
  margin: 0 0 0.5rem;
}

p {
  margin: 0 0 1rem;
  line-height: 1.5;
}

/* Primary CTA — matches library accent */
#sandbox-starter-cta {
  font: inherit;
  padding: 0.5rem 1rem;
  border: 1px solid var(--nogrok-preview-primary);
  border-radius: 6px;
  background: color-mix(in srgb, var(--nogrok-preview-primary) 14%, transparent);
  color: var(--nogrok-preview-on-surface);
  cursor: pointer;
}

#sandbox-starter-cta:hover {
  background: color-mix(in srgb, var(--nogrok-preview-primary) 22%, transparent);
}`,
  js: `// Parent page listens for this payload (see sandbox Preview postMessage handler).
document.getElementById('sandbox-starter-cta')?.addEventListener('click', () => {
  window.parent.postMessage(
    { source: '${SANDBOX_PREVIEW_POSTMESSAGE_SOURCE}', type: 'highlight-library-tab' },
    '*',
  )
})`,
}

export default preset
